import { render, staticRenderFns } from "./Index1.vue?vue&type=template&id=d5c7da4a&"
import script from "./Index1.vue?vue&type=script&lang=js&"
export * from "./Index1.vue?vue&type=script&lang=js&"
import style0 from "./Index1.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports